/* eslint-disable max-lines */
import React, { ReactElement, memo, useCallback } from "react";

// interfaces
import { GetPaymentMethodsResponse } from "@payment-client/interfaces/PaymentApi";

// components
import { PaymentGroupHandlerProps } from "@payment-client/components/show-payments/components/payment-group-handler/interfaces";
import { PaymentActionProvider } from "@payment-client/components/show-payments/components/payment-action-provider";
import { PaymentGroupHandler } from "@payment-client/components/show-payments/components/payment-group-handler";

//helpers
import { isEmpty } from "@swiggy-private/core-ui";

interface PaymentOfferUIHandlerProps extends Pick<PaymentGroupHandlerProps, "options"> {
    paymentGroups: GetPaymentMethodsResponse["paymentOffersGroup"];
    paymentAmount: string;
}

export const PaymentOfferUIHandler = memo(function PaymentOfferUIHandler({
    paymentGroups,
    paymentAmount,
    ...props
}: PaymentOfferUIHandlerProps): ReactElement | null {
    const renderPaymentGroups = useCallback(
        (
            paymentActions: Pick<PaymentGroupHandlerProps, "selectedPaymentId" | "onSelect" | "onPay">,
            paymentGroups?: GetPaymentMethodsResponse["paymentGroup"],
        ): ReactElement[] | null => {
            if (isEmpty(paymentGroups)) {
                return null;
            }
            return paymentGroups.map(paymentGroup => (
                <PaymentGroupHandler
                    paymentAmount={paymentAmount}
                    paymentGroup={paymentGroup}
                    key={paymentGroup.groupName}
                    paymentInProgress={false}
                    {...paymentActions}
                    {...props}
                />
            ));
        },
        [paymentAmount, props],
    );

    return (
        <PaymentActionProvider>
            {({ placeOrderInProgress, onMorePaymentsOptionSelect, ...paymentActions }): ReactElement => (
                <> {renderPaymentGroups(paymentActions, paymentGroups)}</>
            )}
        </PaymentActionProvider>
    );
});
